<template>
    <div class="content">
        <div class="rec-list wrap">
            <ul v-if="recList.length > 0">
                <li class="vc" v-for="(item, index) in recList" :key="index">
                    <div class="rec-info vc">
                        <span class="tel">{{formatTel(item.mobile)}}</span>
                        <i class="icon icon-line" v-if="item.lastName || item.firstName"></i>
                        <span class="name" v-if="item.lastName || item.firstName">{{item.lastName + item.firstName}}</span>
                        <span class="status-tip hvc register" v-if="item.referrerStatus === 0">已注册</span>
                        <span class="status-tip hvc first-pay" v-if="item.referrerStatus === 1">完成线上首单预订</span>
                    </div>
                    <div class="reward-score">+{{thousands(item.point)}}</div>
                </li>
            </ul>
            <div class="blank-tip hvc" v-else>
                <div class="tip-box">
                    <i class="icon icon-blank"></i>
                    <p>暂时没有推荐用户</p>
                    <p>快去推荐好友吧!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { hideTel, thousands } from '@/libs/tools'
    import axios from '@/libs/api.request'
    export default {
        name: 'recommendList',
        data: () => {
            return {
                recList: []
            }
        },
        beforeMount () {
            this.$router.replace('/member/index?showRec=true')
        },
        mounted () {
            this.getReferrerList()
                .then(res => {
                    this.recList = res
                })
        },
        methods: {
            formatTel (tel) {
                return hideTel(tel)
            },
            thousands (num) {
                return thousands(num)
            },
            getReferrerList () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetReferrerList',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .rec-list{
        padding-top: 1.24rem;
        li{
            justify-content: space-between;
            -webkit-justify-content: space-between;
            height: 0.94rem;
        }
        .rec-info{
            height: 0.40rem;
            line-height: 1;
            .icon-line{
                width: 0;
                height: 0.27rem;
                margin: 0 0.14rem;
                border-right: #282b2c solid 1px;
            }
            .status-tip{
                height: 0.34rem;
                padding: 0 0.12rem;
                margin-left: 0.14rem;
                border-radius: 0.03rem;
                font-size: 0.20rem;
                &.register{
                    background-color: #4a90e2;
                    color: #fff;
                }
                &.first-pay{
                    background-color: #fbc500;
                }
            }
        }
        .reward-score{
            color: #f9a115;
            font-size: 0.30rem;
            font-weight: bold;
        }
    }
    .blank-tip{
        height: calc(100vh - 1.24rem);
        .tip-box{
            width: 2.75rem;
            margin-top: -0.80rem;
            text-align: center;
            .icon-blank{
                width: 2.03rem;
                height: 1.73rem;
                margin-bottom: 0.30rem;
                background: url("../../../assets/images/blank.png") no-repeat;
                background-size: 100% 100%;
            }
            p{
                color: #919b9f;
                line-height: 0.38rem;
            }
        }
    }
</style>
